import React, { useState, useEffect, useRef } from 'react'

import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, FormControl,
    InputLabel, Select, MenuItem, Grid, Tooltip, Paper, IconButton, InputBase,
    Divider, List, Switch, FormControlLabel, TextField
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import EmojiTextarea from '../../../Input/EmojiTextarea';
import useNotification from '../../../Notification';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ListItemButton from '@mui/material/ListItemButton';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import ReactHtmlParser from 'react-html-parser';
import DraggableBox from '../../../../utils/draggableBox';
import ConfirmationDialogCaptcha from '../../../Dialogs/ConfimationDialogCaptcha';

import { getSession } from "../../../../auth"

const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top" />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 200,
    },
});

export const PredefinedDropdown = ({ target, index = '' }) => {

    const dropref = useRef()
    const buttonref = useRef()
    const [showOptions, setShowOptions] = useState(false)

    const title_message = `
    selecione opcionalmente uma das variáveis abaixo.
    `

    const setTarget = (variable, index = ' ') => {
        target(variable, index)
    }

    function getAbsPosition(element) {
        var rect = element.getBoundingClientRect();
        return { x: rect.left, y: rect.top }
    }

    const moveDiv = () => {


        const selectedDiv = dropref?.current
        const selectedButton = buttonref?.current

        const coords = getAbsPosition(selectedButton);

        const posX = coords.x
        const posY = coords.y

        selectedDiv.style.left = `${posX}px`
        selectedDiv.style.top = `${posY}px`

        setShowOptions(true)
    }


    return (
        <>
            <CustomWidthTooltip title={title_message}>
                <IconButton ref={buttonref} className='absolute-button' onClick={e => {e.preventDefault(); moveDiv()}}>
                    <KeyboardArrowDownIcon />
                </IconButton>
            </CustomWidthTooltip>

            <Box className={`select-pop-up-backdrop ${showOptions ? 'active': ''}`} onClick={() => setShowOptions(false)}></Box>

            <Box ref={dropref} className={`select-pop-up ${showOptions ? 'active': ''}`}>
                <List className='select-list insiderlist'>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => { setTarget('{{nome_cliente}}', index); setShowOptions(false) }}
                    >
                        Nome do contato
                    </ListItemButton>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => { setTarget('{{nome_operador}}', index); setShowOptions(false) }}
                    >
                        Nome do operador
                    </ListItemButton>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => { setTarget('{{codigo_cliente}}', index); setShowOptions(false) }}
                    >
                        Código
                    </ListItemButton>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => { setTarget('{{aniversario_cliente}}', index); setShowOptions(false) }}
                    >
                        Aniversário
                    </ListItemButton>
                </List>
            </Box>
        </>
    )
}

const PredefinedMessagesModal = ({ title, messages, addMessage, selected, handleClose, deleteCategory }) => {
    const parseQueueIds = (message) => {
        if (!message) return [0]

        const mapQueueIds = (items) => items
            .map((item) => {
                if (typeof item === "object" && item !== null)
                    return Number(item.id ?? item.queue_id ?? item.queue)
                return Number(item)
            })
            .filter((value) => !Number.isNaN(value) && value > 0)

        let queueIds = []
        if (Array.isArray(message.queue_ids))
            queueIds = mapQueueIds(message.queue_ids)
        else if (Array.isArray(message.queues))
            queueIds = mapQueueIds(message.queues)
        else if (message.queue_id !== undefined && message.queue_id !== null) {
            const queueId = Number(message.queue_id)
            if (!Number.isNaN(queueId) && queueId > 0)
                queueIds = [queueId]
        }

        const normalized = [...new Set(queueIds)]
        return normalized.length > 0 ? normalized : [0]
    }

    const normalizeQueueSelection = (queueSelection) => {
        const values = Array.isArray(queueSelection) ? queueSelection : [queueSelection]
        const normalized = [...new Set(
            values
                .map((value) => Number(value))
                .filter((value) => !Number.isNaN(value))
        )]
        if (normalized.length === 0) return [0]
        return normalized
    }

    const [category, setCategory] = useState(selected?.category || "")
    const [queue, setQueue] = useState(parseQueueIds(selected))
    const [newCategory, setNewCategory] = useState("")
    const [categorys, setCategorys] = useState([])
    const [showAddCategory, setShowAddCategory] = useState(false)
    const [textEdit, setTextEdit] = useState(selected?.message || "")
    const [isHtml, setIsHtml] = useState(selected?.is_html || false)
    const [showHtmlPreview, setShowHtmlPreview] = useState(false)
    const [htmlTitle, setHtmlTitle] = useState(selected?.title || "")
    const [showDeleteCategoryDialog, setShowDeleteCategoryDialog] = useState(false)

    const selectedItemSx = {
        '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)'
        },
        '&.Mui-selected:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.18)'
        }
    }

    useEffect(() => {
        const newcategorys = messages.map(each => each.category)
        setCategorys(newcategorys.filter((value, index, array) => array.indexOf(value) === index))
    }, [messages])

    useEffect(() => {
        setQueue(parseQueueIds(selected))
    }, [selected])

    const addPredefinedMessage = async () => {
        await addMessage(textEdit, category, queue, selected ? selected.id : 0, isHtml, isHtml ? htmlTitle : null)
        handleClose()
    }

    const addCategory = () => {
        setShowAddCategory(false)
        if (categorys.includes(newCategory)) {
            useNotification(
                'Erro!',
                'Categoria já existe.',
                'danger'
            );
            return
        }
        useNotification(
            'Sucesso!',
            'Categoria adicionada com sucesso.',
            'success'
        );
        categorys.push(newCategory)
    }

    const handleDeleteCategory = async () => {
        if (category && deleteCategory) {
            await deleteCategory(category)
            setShowDeleteCategoryDialog(false)
            setCategory("")
        }
    }

    const onKeyDownPredefinedMessage = (event) => {
        // key shift off and enter on
        if (!event.shiftKey && (event.keyCode === 13 || event.key === 'Enter')) {
            addPredefinedMessage();
            event.preventDefault();
        }
    }

    const setFormattingOnBody = (formattingCharacter) => {
        if (!textEdit) return;

        const textarea = document.getElementById('html-message-textarea');
        const caretIndexStart = textarea?.selectionStart || 0;
        const caretIndexEnd = textarea?.selectionEnd || 0;
        const selectedText = textEdit.substring(caretIndexStart, caretIndexEnd);

        if (selectedText) {
            setTextEdit(textEdit.substring(0, caretIndexStart) + `${formattingCharacter}${selectedText}${formattingCharacter.replace('<', '</')}` + textEdit.substring(caretIndexEnd, textEdit.length));
        } else {
            setTextEdit(textEdit.substring(0, caretIndexStart) + `${formattingCharacter}${formattingCharacter.replace('<', '</')}` + textEdit.substring(caretIndexStart, textEdit.length));
        }
    }

    return (
        <>
            <ConfirmationDialogCaptcha
                open={showDeleteCategoryDialog}
                title="Excluir categoria"
                description={
                    <Box>
                        <Box sx={{ color: 'error.main', mb: 2 }}>
                            Todas as mensagens da categoria <strong>{category}</strong> serão excluídas.
                        </Box>
                        <Box>
                            Para confirmar a ação, digite: <strong>remover</strong> no campo abaixo.
                        </Box>
                    </Box>
                }
                handleClose={() => setShowDeleteCategoryDialog(false)}
                handleSubmit={handleDeleteCategory}
                captcha="remover"
                alternateYes="Confirmar"
                alternateNo="Cancelar"
            />
            <Dialog keepMounted
                open={true}
                onClose={() => { }}
                aria-labelledby="customized-dialog-title"
                disablePortal
                disableEnforceFocus
                sx={{position:'absolute'}}
                maxWidth={isHtml ? 'md' : 'sm'}
                fullWidth={isHtml}
            >
                <DialogTitle id="customized-dialog-title"
                    className={'group-flexbox'}
                    style={{
                        minWidth: isHtml ? "700px" : "500px"
                    }}
                >
                    <span>{title}</span> <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2}>
                        {!showAddCategory
                            ? <Box display="flex">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Categoria</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Categoria"
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                    >
                                        {categorys.map(category =>
                                            <MenuItem key={category} value={category}>{category}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                                <Tooltip title="Nova categoria" placement="bottom" disableInteractive>
                                    <IconButton
                                        onClick={() => setShowAddCategory(true)}
                                        style={{ marginLeft: "10px" }}
                                        size="medium"
                                    >
                                        <AddIcon className="icon-add" />
                                    </IconButton>
                                </Tooltip>
                                {deleteCategory && category && (
                                    <Tooltip title="Excluir categoria" placement="bottom" disableInteractive>
                                        <IconButton
                                            onClick={() => setShowDeleteCategoryDialog(true)}
                                            size="medium"
                                            color="error"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                            : <Paper
                                sx={{
                                    p: '2px 4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: 450,
                                    bgcolor: '#efefef'
                                }}
                            >
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Nova categoria"
                                    onChange={(e) => setNewCategory(e.target.value)}
                                />
                                <Tooltip title="Adicionar" placement="bottom" disableInteractive>
                                    <IconButton onClick={addCategory} >
                                        <AddIcon className="icon-add" />
                                    </IconButton>
                                </Tooltip>
                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <Tooltip title="Cancelar" placement="bottom" disableInteractive>
                                    <IconButton onClick={() => setShowAddCategory(false)}>
                                        <CloseIcon className="icon-cancel" />
                                    </IconButton>
                                </Tooltip>
                            </Paper>
                        }
                        <FormControl fullWidth size="small">
                            <InputLabel>Fila</InputLabel>
                            <Select
                                multiple
                                label="Fila"
                                value={queue}
                                onChange={(event) => {
                                    const normalizedValues = normalizeQueueSelection(event.target.value)
                                    if (normalizedValues.includes(0) && normalizedValues.length > 1) {
                                        if (queue.includes(0)) {
                                            setQueue(normalizedValues.filter((value) => value !== 0))
                                        } else {
                                            setQueue([0])
                                        }
                                        return
                                    }
                                    setQueue(normalizedValues)
                                }}
                                renderValue={(selectedValues) => {
                                    const normalizedValues = normalizeQueueSelection(selectedValues)
                                    if (normalizedValues.includes(0))
                                        return "Qualquer Fila"

                                    const queueDescriptions = normalizedValues
                                        .map((queueId) => getSession().profile?.enterprise?.queues.find((q) => q.id === queueId)?.description)
                                        .filter(Boolean)

                                    return queueDescriptions.join(", ")
                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    sx={selectedItemSx}
                                >
                                    Qualquer Fila
                                </MenuItem>
                                <Divider />
                                {getSession().profile?.enterprise?.queues
                                    .filter((q) => !q.name.split("_")[1].startsWith("0000"))
                                    .map((q) =>
                                        <MenuItem
                                            key={q.id}
                                            value={q.id}
                                            sx={selectedItemSx}
                                        >
                                            {q.description}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isHtml}
                                    onChange={(e) => setIsHtml(e.target.checked)}
                                    color="primary"
                                />
                            }
                            label="Mensagem HTML"
                        />
                        {isHtml ? (
                            <Box display="flex" flexDirection="column" gap={1}>
                                <TextField
                                    size="small"
                                    label="Título"
                                    fullWidth
                                    variant="outlined"
                                    inputProps={{ maxLength: 200 }}
                                    value={htmlTitle}
                                    onChange={(e) => setHtmlTitle(e.target.value)}
                                    placeholder="Digite um título para identificar esta mensagem..."
                                />
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <Tooltip title="Negrito">
                                        <IconButton onClick={() => setFormattingOnBody('<strong>')} size="small">
                                            <FormatBoldIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Itálico">
                                        <IconButton onClick={() => setFormattingOnBody('<em>')} size="small">
                                            <FormatItalicIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Tachado">
                                        <IconButton onClick={() => setFormattingOnBody('<s>')} size="small">
                                            <StrikethroughSIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Visualizar HTML">
                                        <IconButton onClick={() => setShowHtmlPreview(true)} size="small">
                                            <VisibilityIcon color="primary" />
                                        </IconButton>
                                    </Tooltip>
                                    <PredefinedDropdown target={(e) => setTextEdit(textEdit + e)} />
                                </Box>
                                <TextField
                                    id="html-message-textarea"
                                    multiline
                                    rows={10}
                                    size="small"
                                    label="Mensagem HTML"
                                    fullWidth
                                    variant="outlined"
                                    inputProps={{ maxLength: 40000 }}
                                    value={textEdit}
                                    onChange={(e) => setTextEdit(e.target.value)}
                                    placeholder="Digite sua mensagem HTML aqui..."
                                />
                                <Box className="character-counter" sx={{ textAlign: 'right', fontSize: '0.75rem', color: 'text.secondary' }}>
                                    {`${textEdit?.length || 0} / 40000 caracteres`}
                                </Box>
                                <DraggableBox
                                    show={showHtmlPreview}
                                    handleClose={() => setShowHtmlPreview(false)}
                                    x={50}
                                    y={-300}
                                    className='draggable-box-email'
                                    title='Visualização HTML'
                                >
                                    {ReactHtmlParser(textEdit)}
                                </DraggableBox>
                            </Box>
                        ) : (
                            <EmojiTextarea
                                text={textEdit}
                                setText={(event) => setTextEdit(event.target.value)}
                                setEmoji={(text) => setTextEdit(text)}
                                onKeyDown={onKeyDownPredefinedMessage}
                                maxLength={1000}
                                label="Mensagem"
                                childComponent="MessageBox"
                                dropdown={(<PredefinedDropdown target={(e)=> setTextEdit(textEdit+e)}/>)}
                            />
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Box display="flex" gap={1} mr={2} mb={1}>
                        <Button onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={addPredefinedMessage}
                            color="primary"
                            disabled={!textEdit || !category || textEdit.trim() === ""}>
                            {selected ? 'Salvar' : 'Adicionar'}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PredefinedMessagesModal
